import { Injectable } from '@angular/core';

import {
  ACCOUNT_PERMISSIONS,
  PermissionGroupSettings,
} from '@libs/src/pre-registration/pre-registration.helper';

@Injectable({ providedIn: 'root' })
export class PreRegistrationService {
  getPermissionGroupSettings(
    memberPermission: ACCOUNT_PERMISSIONS,
  ): PermissionGroupSettings {
    switch (memberPermission) {
      case ACCOUNT_PERMISSIONS.tenant_admin: {
        return {
          groups: {},
          isAdmin: true,
        };
      }
      case ACCOUNT_PERMISSIONS.dev_pro_admin: {
        return {
          groups: {
            feature_admin: {
              programs: true,
            },
          },
        };
      }
      case ACCOUNT_PERMISSIONS.hub_admin: {
        return {
          groups: {
            isAdmin: true,
          },
        };
      }
      default: {
        return { groups: {} };
      }
    }
  }
}
